import { EPhotoEditorConsumer } from 'shared/enums/EPhotoEditorConsumer';
import {
  IRepresentativeSingleProfileMedia,
  IRepresentativeSingleProfileHiddenMedia,
} from 'shared/interfaces/IRepresentativesEditProfile';
import { isJsonString, imageURLtoFile } from 'shared/utils/common';
import { useEditProfilePhotoEditor } from '../context/EditProfilePhotoEditorV2Provider';
import { v4 as uuidv4 } from 'uuid';

export const useEditProfileMediaImageEdit = () => {
  const { handlePhotoEditorOpen } = useEditProfilePhotoEditor();

  const onAttachedEditorClick = (attached_image: IRepresentativeSingleProfileMedia) => {
    const mediumName = isJsonString(attached_image.medium.file_name)
      ? JSON.parse(attached_image.medium.file_name).filename
      : attached_image.medium.file_name;

    const filename = JSON.stringify({
      filename: mediumName,
      id: attached_image.medium.id,
      isPrimary: attached_image.primary,
      isCroppedAttachmentNull: attached_image?.medium?.cropped_attachment_url === null,
    });

    imageURLtoFile(attached_image.medium.attachment_url, filename).then((file) => {
      handlePhotoEditorOpen([file], EPhotoEditorConsumer.PROFILE_MEDIA_EDITOR);
    });
  };

  const onHiddenEditorClick = (hidden_image: IRepresentativeSingleProfileHiddenMedia) => {
    const prepFilename = JSON.stringify({
      filename: uuidv4(),
      id: hidden_image?.id,
    });
    imageURLtoFile(hidden_image.attachment_url, prepFilename).then((file) => {
      handlePhotoEditorOpen([file], EPhotoEditorConsumer.PROFILE_MEDIA_EDITOR);
    });
  };

  return { onAttachedEditorClick, onHiddenEditorClick };
};
